import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer

import AccountResources from './../../Account/Resources/commonfunctions.js'; //Account
//import AccountResources from './../Template/script'; //Account

let service = new services();
export default {
    name: 'Home',
    mixins: [AccountResources],
    data () {
        return {
            header_data:{},
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
    },
    computed: {},
    methods: {
        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    self.loggedIn = true;
                    self.setSiteUser();
                    self.loading = false;
                }else {
                    self.$router.push('login');
                    // console.log(err)
                }
            });
        },

        setPageCalls(){
            this.getBusinessProcessingFeesTransactions();
        },
        
        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
            })
        },
    },
    created: function(){
        this.header_data.name = "Setup Shop";
        this.preset();
        this.getRavepayBanks();
        this.getBusinessCategories();
    }
}


// WEBPACK FOOTER //
// ./src/pages/AgentServices/SetUpShop/script.js